/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const AddMyEmailResponse = zod.object({
  emails: zod.array(
    zod.object({
      email: zod.email().describe('The email address'),
      primary: zod
        .boolean()
        .describe('True for the primary address (login\/JWT claim and profile email)'),
      verified: zod.boolean().describe('True once the address has passed OTP verification'),
    }),
  ),
  verification: zod
    .object({
      csrfToken: zod.string(),
      email: zod.email(),
      expiresAt: zod.string(),
      flowId: zod.string().min(1),
    })
    .optional()
    .describe(
      'Verification flow state to echo back on \/me\/emails\/verify. Absent when the OTP email could not be dispatched (the address was still added; use \/me\/emails\/resend).',
    ),
});

export type AddMyEmailResponse = zod.input<typeof AddMyEmailResponse>;
export type AddMyEmailResponseOutput = zod.output<typeof AddMyEmailResponse>;
